import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CachedIcon from '@mui/icons-material/Cached';
import TimeAgoView from './TimeAgoView';
import { REQUEST_STATUS } from '@shared/constants/otherConstants';
import UtmsButton from '@shared/components/ui/UtmsButton';
import { Box } from '@mui/material';

const RefreshButton = ({ getStatus, ...restProps }) => {
    const { t } = useTranslation();
    const [lastRefreshTime, setLastRefreshTime] = useState(null);

    useEffect(() => {
        if (getStatus === REQUEST_STATUS.SUCCESS) {
            setLastRefreshTime(Date.now());
        }
    }, [getStatus]);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <UtmsButton sx={{ whiteSpace: 'nowrap' }} startIcon={<CachedIcon />} {...restProps}>
                {t('refresh')}
            </UtmsButton>
            {Boolean(lastRefreshTime) && <TimeAgoView date={lastRefreshTime} />}
        </Box>
    );
};

export default RefreshButton;
